module.exports = __webpack_public_path__ + "static/media/arrow-send.a8ee8d83.svg";